import {
  INBOUND_CONSOLIDATION_STATUS_MAP,
  OUTBOUND_CONSOLIDATION_STATUS_MAP,
} from '@returnmates/client-core/src/constants/trip'
import { memo } from 'react'
import { Field, useField } from 'react-final-form'

import { FLYOUT_SIDEBAR_TYPES } from '../../../constants/flyoutSidebar'
import EditAddressFormInner from '../../EditAddressForm/EditAddressFormInner'
import ExpandableSection from '../../ExpandableSection'
import Select from '../../Select'
import useStyles from '../styles'
import BarcodeScans from './BarcodeScans'
import Information from './Information'
import LabelsAndManifest from './LabelsAndManifest'
import LocationScans from './LocationScans'

interface Props {
  id: string
  type: string
  partnerCode?: string
}

function EditConsolidationFormInner({ id, type, partnerCode }: Props) {
  const classes = useStyles()
  const { input: scans } = useField('scans')
  const { input: locationScans } = useField('locationScans')

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Status</p>
        <Field name="status">
          {({ input }) => (
            <Select
              value={input.value}
              onChange={input.onChange}
              values={
                type === FLYOUT_SIDEBAR_TYPES.EDIT_CONTAINER
                  ? OUTBOUND_CONSOLIDATION_STATUS_MAP
                  : INBOUND_CONSOLIDATION_STATUS_MAP
              }
              className={classes.select}
              showItemIcon
              fullWidth
            />
          )}
        </Field>
      </div>
      <ExpandableSection isExpandedByDefault title="Customer Information">
        <EditAddressFormInner
          isReadOnly={type === FLYOUT_SIDEBAR_TYPES.EDIT_CONTAINER}
          partnerCode={partnerCode}
          type={FLYOUT_SIDEBAR_TYPES.EDIT_CONSOLIDATION_ADDRESS}
        />
      </ExpandableSection>

      <ExpandableSection title="Information">
        <Information id={id} />
      </ExpandableSection>

      <ExpandableSection title="Labels and Manifest">
        <LabelsAndManifest id={id} type={type} />
      </ExpandableSection>

      {scans.value.length ? (
        <ExpandableSection childrenType="table" title="Barcode Scans">
          <BarcodeScans />
        </ExpandableSection>
      ) : null}

      {locationScans.value.length ? (
        <ExpandableSection childrenType="table" title="Location Scans">
          <LocationScans />
        </ExpandableSection>
      ) : null}
    </>
  )
}

export default memo(EditConsolidationFormInner)
